export default "__VITE_ASSET__57895571__"